exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".success {\n    background-image: url('/images/confetti.png');\n    background-size: cover;\n    padding: 80px 24vw 80px 24vw;\n}\n\n.success button {\n    font-weight: bold;\n}\n\n@media only screen and (max-width: 768px) {\n    .success {\n        padding: 20px 10px 40px 10px;\n    }   \n    \n    .page-logo {\n        width: 20vw;\n        height: auto;\n    }\n    \n    .page-title.title.is-4 {\n        margin: 0;\n        /*font-size: 8vw;*/\n    }\n    \n    .success .description {\n        font-size: 14px;\n    }\n    \n    .success button {\n        width: 80%;\n        margin: 0;\n    }\n    \n    .bottom-text {\n        font-size: 12px;\n    }\n}\n\n@media only screen and (max-width: 360px) {\n    .page-title.title.is-3 {\n        font-size: 8.75vw;    \n    }\n}\n\n@media only screen and (max-width: 420px) {\n    .description strong {\n        font-size: 3.3vw;    \n        line-height: 50%;\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/pages/Success.css
// module id = 346
// module chunks = 0